import css from 'styled-jsx/css';
import { common } from '../../theme/theme';

const style = css`
  .update-pricing-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .pricing-selector-wrapper {
    margin-bottom: 8px;
  }
  .update-pricing-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .update-pricing-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
